<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="toc">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="toc">
<h1 class="toc">CONTENTS</h1>
<p class="toc"><a href="#/OEBPS/9781454940760_epub_int_r1"><b><i>Introduction</i></b></a></p>
<p class="toc"><a href="#/OEBPS/9781454940760_epub_ch1_r1"><span class="toc1"><b>CHAPTER 1</b></span><br/><b>Cooking with Cannabis: Kitchen Basics</b></a></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_ch2_r1" title="Link target outside of Sample"><span class="toc1"><b>CHAPTER 2</b></span><br/><b>Morning Beverages and Light Meals</b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_ch3_r1" title="Link target outside of Sample"><span class="toc1"><b>CHAPTER 3</b></span><br/><b>Snacks</b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_ch4_r1" title="Link target outside of Sample"><span class="toc1"><b>CHAPTER 4</b></span><br/><b>Light Main Meals</b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_ch5_r1" title="Link target outside of Sample"><span class="toc1"><b>CHAPTER 5</b></span><br/><b>Desserts</b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_ch6_r1" title="Link target outside of Sample"><span class="toc1"><b>CHAPTER 6</b></span><br/><b>Drinks</b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_apa_r1" title="Link target outside of Sample"><span class="toc1"><b>APPENDIX A</b></span><br/><b>Cannabis Basics: Understanding the Human Endocannabinoid System</b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_apb_r1" title="Link target outside of Sample"><span class="toc1"><b>APPENDIX B</b></span><br/><b>Cannabis for Symptom Relief</b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_aft_r1" title="Link target outside of Sample"><span class="toc1"><b>AFTERWORD</b></span><br/><b>How Cannabis Raises Our Spirits</b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_gls_r1" title="Link target outside of Sample"><b><i>Glossary</i></b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_ack_r1" title="Link target outside of Sample"><b><i>Acknowledgments</i></b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_bib_r1" title="Link target outside of Sample"><b><i>Bibliography</i></b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_res_r1" title="Link target outside of Sample"><b><i>Resources</i></b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_cre_r1" title="Link target outside of Sample"><b><i>Photography Credits</i></b></span></p>
<p class="toc"><span href="#/OEBPS/9781454940760_epub_ata_r1" title="Link target outside of Sample"><b><i>About the Author</i></b></span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454940760_epub_toc_r1.vue?12ff1f4c